export const StreamingConstants = Object.freeze({
    STREAMING_SERVER_URL: 'wss://stream.test.viliyo.com',
    // STREAMING_SERVER_URL: 'wss://openvidustream.akashkumarshukla.in',

})